<template>
  <div class="pure-progress-bar">
    <div
      class="pure-progress-bar-fill answered"
      :style="{ flex: answered }"
    ></div>
    <div
      class="pure-progress-bar-fill unanswered"
      :style="{ flex: unanswered }"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    total: {
      type: Number,
      default: 1,
    },
    answered: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    unanswered() {
      return this.total - this.answered;
    },
  },
};
</script>

<style scoped lang="scss">
.pure-progress-bar {
  border-radius: var(--radius-md);
  display: flex;
  height: 4px;
  overflow: hidden;
  width: 100%;

  @include breakpoint(tablet) {
    width: rem-calc(150);
  }

  @include breakpoint(desktop) {
    width: rem-calc(150);
  }
}

.pure-progress-bar-fill {
  transition: flex 0.8s ease-out;
}

.answered {
  background-color: #4fb9de;
}

.unanswered {
  background-color: rgba(153, 164, 174, 0.2);
}
</style>
